import React from 'react';
import './App.css';
import { Router, Route, HashRouter } from "react-router-dom"
import { createBrowserHistory } from 'history'
import { initializeApp, apps } from "firebase/app";

import Index from "./Pages/Index";

export const history = createBrowserHistory();

const config = {
	apiKey: "AIzaSyDPTWQphyQSOV6oQ85upxImorqpjXlHvk8",
	authDomain: "democracydelivery.firebaseapp.com",
	projectId: "democracydelivery",
	storageBucket: "democracydelivery.appspot.com",
	messagingSenderId: "380591047861",
	appId: "1:380591047861:web:92f30f9e6c88eefd996afc"
};

function App() {
	if (!apps.length) initializeApp( config );

	return (
		<div className="App">
			<Router history={history}>
				<HashRouter>
					<Route path="/" component={Index}/>
				</HashRouter>
			</Router>
		</div>
	);
}

export default App;
